var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_6819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 2.42208C0.666504 1.41088 1.47796 0.588745 2.47603 0.588745H11.5236C12.5217 0.588745 13.3332 1.41088 13.3332 2.42208V13.4221C13.3332 14.4333 12.5217 15.2554 11.5236 15.2554H2.47603C1.47796 15.2554 0.666504 14.4333 0.666504 13.4221V2.42208ZM7.9046 13.4221C7.9046 13.179 7.80928 12.9458 7.6396 12.7739C7.46992 12.602 7.23979 12.5054 6.99984 12.5054C6.75988 12.5054 6.52975 12.602 6.36007 12.7739C6.1904 12.9458 6.09508 13.179 6.09508 13.4221C6.09508 13.6652 6.1904 13.8984 6.36007 14.0703C6.52975 14.2422 6.75988 14.3387 6.99984 14.3387C7.23979 14.3387 7.46992 14.2422 7.6396 14.0703C7.80928 13.8984 7.9046 13.6652 7.9046 13.4221ZM11.5236 2.42208H2.47603V11.5887H11.5236V2.42208Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_6819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6667,
    height: 14.6667,
    fill: "currentColor",
    transform: "translate(0.666504 0.588745)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationNavigation);
export default __webpack_public_path__ + "static/media/application-navigation.fb323d9f201df7c54c03fcd73ab2e8a6.svg";
export { ForwardRef as ReactComponent };